// extracted by mini-css-extract-plugin
module.exports = {"ko-KR":"seller-badges_ko-KR__N3HuL","impressionTrackingContainer":"seller-badges_impressionTrackingContainer__V1SN8","sellerBadge":"seller-badges_sellerBadge__HEKQb"};